<app-nav-bar *ngIf="authService.isLoggedIn">
</app-nav-bar>
<!-- <div [@slideInAnimation]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet #o="outlet"></router-outlet>
</div> -->
<router-outlet></router-outlet>